module.exports = __webpack_public_path__ + "static/media/footer_shape_3.0d1a9f4b.png";